import type { ThemeOptions } from "@mui/material/styles";
import { createTheme } from "@mui/material/styles";
import { ptBR } from "@mui/x-date-pickers/locales";
import merge from "lodash.merge";

const buildDefaultTheme = (theme: ThemeOptions) => {
  if (window.themeOptions && Object.keys(window.themeOptions).length) {
    return merge({}, theme, window.themeOptions) as ThemeOptions;
  }
  return theme;
};

export const themeOptions: ThemeOptions = buildDefaultTheme({
  shape: {
    borderRadius: 4,
  },
  palette: {
    text: { primary: "rgba(0, 0, 0, 0.87)" },
    common: { black: "rgba(0, 0, 0, 0.87)", white: "rgba(255, 255, 255, 1)" },
    primary: {
      main: "#2F16C9",
      light: "#7D4EE4",
      dark: "#0C1C69",
    },
    secondary: {
      main: "#0C1B69",
      dark: "#091448",
      light: "#707DBA",
    },
    success: {
      main: "#2E7D32",
      dark: "#1B5E20",
      light: "#4CAF50",
    },
    error: {
      main: "#D32F2F",
      dark: "#B71C1C",
      light: "#EF5350",
    },
    warning: {
      main: "#EF6C00",
      dark: "#C7591E",
      light: "#FFA726",
    },
    info: {
      main: "#03A9F4",
      dark: "#01579B",
      light: "#81D4FA",
    },
    background: {
      default: "#FAFAFA",
      paper: "#FFFFFF",
    },
    action: {
      active: "rgba(0, 0, 0, 0.56)",
      hover: "rgba(0, 0, 0, 0.04)",
      selected: "rgba(0, 0, 0, 0.08)",
      focus: "rgba(0, 0, 0, 0.12)",
      disabled: "rgba(0, 0, 0, 0.12)",
    },
  },
  typography: {},
  components: {
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          "&$focused $notchedOutline": {
            borderColor: "#a6a6a6",
          },
        },

        notchedOutline: {
          borderColor: "#a6a6a6",
        },
      },
    },

    MuiInput: {
      styleOverrides: {
        underline: {
          "&:after": {
            borderBottomColor: "#a6a6a6",
          },
          "&:before": {
            borderBottomColor: "#a6a6a6",
          },
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          "&$focused": {
            color: "#a6a6a6",
          },
        },
      },
    },

    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          backgroundColor: "#f5f5f9",
          color: "rgba(0, 0, 0, 0.87)",
          boxShadow:
            "rgb(0 0 0 / 20%) 0px 3px 3px -2px, rgb(0 0 0 / 14%) 0px 3px 4px 0px, rgb(0 0 0 / 12%) 0px 1px 8px 0px",
          fontSize: 11,
        },
      },
    },
  },
});

export default createTheme(themeOptions, ptBR);
